
import { getUid, replaceTagCode } from '@/utils/util.js'
function flattenArray(arr) {
  return arr.reduce(
    (acc, val) =>
      Array.isArray(val) ? acc.concat(flattenArray(val)) : acc.concat(val),
    []
  );
}
export const getPreviewData = (data, sendType = 0) => {
  let result = []; // {}
  console.log('getPreview 获取的原始数据：', data);
  const allTabData = data.allTabData || [];
  allTabData.forEach((item) => {
    const sendTarget = item.sendTarget;

    sendTarget.forEach((target) => {
      const isIncluded = result.some((resV) => {
        if (resV.studentCode == target.studentCode) {
          resV.sendContents = resV.sendContents.concat(
            flattenArray(
              item.sendContent.map((v) => {
                if (v.filePaths) {
                  // 通用文件类型的
                  return v.filePaths.map((f) => ({
                    ...f,
                    msgType: v.msgType,
                    tabId: item.tabId
                  }));
                } else if (Array.isArray(v.sendContent)) {
                  // 个性化文件类型的
                  let paths = [];
                  v.sendContent.forEach((item2) => {
                    if (item2.studentCode == target.studentCode) {
                      // 是这个人的
                      paths = paths.concat(item2.filePaths); // TODO 
                    }
                  });
                  return paths.map((item3) => {
                    //item2 {studentName:'',studentCode:'',filePaths: [{ path: '/usr/renjinhui/document/qqqq/张三.pdf' }]}
                    return {
                      ...item3,
                      msgType: v.msgType,
                      tabId: item.tabId
                    };
                  });
                } else {
                  // 普通文本
                  return {
                    ...v,
                    tabId: item.tabId,
                    sendContent: replaceTagCode(v.sendContent, target)
                  };
                }
              }).reverse()
            )
          );
          return true;
        }
      });
      if (!isIncluded) {
        // 还没有这个人的 新增
        result.push({
          ...target,
          sendContents: flattenArray([
            ...item.sendContent.map((v) => {
              if (v.filePaths) {
                // 通用文件类型的
                return v.filePaths.map((f) => ({
                  ...f,
                  msgType: v.msgType,
                  tabId: item.tabId
                }));
              } else if (Array.isArray(v.sendContent)) {
                // 个性化文件类型的
                let paths = [];
                v.sendContent.forEach((item2) => {
                  if (item2.studentCode == target.studentCode) {
                    // 是这个人的
                    paths = paths.concat(item2.filePaths);
                  }
                });
                return paths.map((item3) => {
                  //item2 {studentName:'',studentCode:'',filePaths: [{ path: '/usr/renjinhui/document/qqqq/张三.pdf' }]}
                  return {
                    ...item3,
                    msgType: v.msgType,
                    tabId: item.tabId
                  };
                });
              } else {
                // 普通文本
                return {
                  ...v,
                  tabId: item.tabId,
                  sendContent: replaceTagCode(v.sendContent, target)
                };
              }
            }).reverse()
          ])
        });
      }
    });
  });
  // console.log('getPreview 处理之后的数据',result)
  result = result.filter(item => item.sendContents.length) // 过滤没有消息的人员
  return result;
};

export const transformDataSendToApp = (data) => {
  console.log('transformDataSendToApp', data)
  const sendObj = {
    name: data.taskName,
    id: data.taskId || getUid(),
  };
  // 好友群发
  const chats = [];
  data.studentMessageDetails.forEach((item) => {
    let chatInfo = {
      // ...item
    };
    chatInfo.id = '' + (item.id || getUid());
    chatInfo.chat_type = data.groupSendObjects[0].sendType
    chatInfo.chat_name = item.receiveName || item.chatGroupName;// TODO:???????
    chatInfo.receiver_info = item.wechatBasicInfo || {};
    chatInfo.student_name = item.studentName;// TODO:???????
    chatInfo.msgs = item.sendContents.map((item2) => {
      let msgInfo = {
        // ...item2
      };
      msgInfo.id = item2.messageId || getUid();
      if (item2.msgType == 'text') {
        msgInfo.type = 1;
        msgInfo.text = replaceTagCode(item2.sendContent, item2);
      } else {
        msgInfo.type = 2;
        msgInfo.file_path = item2.path;
      }
      return msgInfo;
    });
    chats.push(chatInfo);
  });
  sendObj.chats = chats;

  return sendObj;
};
export const transformTableDataSendToApp = (data) => {
  console.log('transformTableDataSendToApp 66', data)
  const sendObj = {
    name: "预览查询时间使用",
    id: data.taskId || getUid(),
  };
  // 好友群发
  const chats = [];
  data.forEach((item) => {
    let chatInfo = {
      // ...item
    };
    chatInfo.id = '' + (item.id || getUid());
    chatInfo.chat_type = item.receiveName ? 1 : 2,
      chatInfo.chat_name = item.receiver || item.receiveName || item.chatGroupName;
    chatInfo.receiver_info = item.wechatBasicInfo || {};
    chatInfo.student_name = item.studentName;
    chatInfo.msgs = (item.sendContents || item.studentWechatMessages).map((item2) => {
      let msgInfo = {
        // ...item2
      };
      msgInfo.id = item2.messageId || getUid();
      if (item2.msgType == 'text') {
        msgInfo.type = 1;
        msgInfo.text = replaceTagCode(item2.sendContent, item2);
      } else {
        msgInfo.type = 2;
        msgInfo.file_path = item2.path;
      }
      return msgInfo;
    });
    chats.push(chatInfo);
  });
  sendObj.chats = chats;

  return sendObj;
};

/**
 * 
 * @param {{
    "id": "6d3eb94b588d48cda17d19891f7162eb",
    "name": "课后服务群发任务",
    "chats": [
        {
            "id": "lyzgwa3ak95cs",
            "chat_name": "冯耀杰",
            "student_name": "冯耀杰",
            "msgs": [
                {
                    "id": "e817a1646d1d48a3bd08609294cbdcdd",
                    "type": 1,
                    "text": "6",
                    "start_time": 1721802754465,
                    "end_time": 1721802756687,
                    "needUpdate": true
                }
            ],
            "chat_type": 1,
            "start_time": 1721802748810,
            "end_time": 1721802756765,
            "needUpdate": true
        }
    ],
    "start_time": 1721802741529,
    "end_time": 1721802758387
}} data 
 */
export function getResultToShowFromAppResData(data) {
  let obj = {
    "taskId": data.id,
    "taskName": data.name,
    "startTime": "" + new Date(data.start_time).toLocaleString(),
    "endTime": "" + new Date(data.end_time).toLocaleString(),
    // "taskType": '', 
    // "total": 0,
    // "sucCount": 0, //这四个暂时不用
    "unSendCount": 0,
    "failCount": 0, // 吧未发送和失败的都算进来
  }
  let failCount = 0;
  if(data.err_code){
    // 任务维度失败 
    failCount = data.chats.length;
  }else{
    data.chats.forEach(chat=>{
      if(chat.err_code){
        // 人失败
        failCount ++;
      }else if(chat.msgs.some(msg=>msg.err_code)){
        // 人下只要有消息失败 不管几个 都算人失败 
        failCount ++;
      }
    })
  }
  obj.failCount = failCount;
  return obj;
}